import _regeneratorRuntime from "@babel/runtime-corejs2/regenerator";
import _asyncToGenerator from "@babel/runtime-corejs2/helpers/esm/asyncToGenerator";
import _classCallCheck from "@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/esm/createClass";
import _assertThisInitialized from "@babel/runtime-corejs2/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime-corejs2/helpers/esm/inherits";
import _createSuper from "@babel/runtime-corejs2/helpers/esm/createSuper";
import _defineProperty from "@babel/runtime-corejs2/helpers/esm/defineProperty";

/* tslint:disable:no-any */
import { DataAccessServiceInterface } from '@central-products/interface-data-access-service';
export var GraphQLClient = /*#__PURE__*/function (_DataAccessServiceInt) {
  _inherits(GraphQLClient, _DataAccessServiceInt);

  var _super = _createSuper(GraphQLClient);

  function GraphQLClient(config, dependencies) {
    var _this;

    _classCallCheck(this, GraphQLClient);

    _this = _super.call(this);

    _defineProperty(_assertThisInitialized(_this), "config", void 0);

    _defineProperty(_assertThisInitialized(_this), "dependencies", void 0);

    _defineProperty(_assertThisInitialized(_this), "client", void 0);

    _this.config = config;
    _this.dependencies = dependencies;
    return _this;
  }

  _createClass(GraphQLClient, [{
    key: "getClient",
    value: function () {
      var _getClient = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _this2 = this;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!this.client) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return", this.client);

              case 2:
                return _context.abrupt("return", import('./createClient').then(function (_ref) {
                  var createClient = _ref.createClient;
                  _this2.client = createClient(_this2.config, _this2.dependencies);
                  return _this2.client;
                }));

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getClient() {
        return _getClient.apply(this, arguments);
      }

      return getClient;
    }()
  }, {
    key: "query",
    value: function query(options) {
      return this.getClient().then(function (client) {
        return client.query(options);
      });
    }
  }, {
    key: "mutate",
    value: function mutate(options) {
      return this.getClient().then(function (client) {
        return client.mutate(options);
      });
    }
  }, {
    key: "watchQuery",
    value: function watchQuery(options) {
      return this.getClient().then(function (client) {
        return client.watchQuery(options);
      });
    }
  }]);

  return GraphQLClient;
}(DataAccessServiceInterface);
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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